import { home_icon } from "assets/icons/icons";

const Summary = () => {
  return (
    <div>
      <div className="shadow-md mt-2 mx-2 flex items-center flex-col justify-center h-[60px]">
        <p className="text-2xl font-bold text-[rgba(0,0,0,.8)]">
          Bert van Duivendijk
        </p>
      </div>
      <div className="shadow-md mt-2 px-3 mx-2">
        <div className="flex items-center h-14 border-b-[1px] border-[rgba(0,0,0,.1)]">
          <img src={home_icon} alt="" />
          <p className="font-bold text-sm ml-1">Details</p>
        </div>
        <div className="flex pb-4">
          <div className="pt-3 ml-6 w-44">
            <p className="text-lightBlack text-sm">Job Title</p>
            <p className="text-lightBlack text-sm mt-3">Firstname</p>
            <p className="text-lightBlack text-sm mt-3">Lastname</p>
            <p className="text-lightBlack text-sm mt-3">Address</p>
          </div>
          <div className="pt-3">
            <p className="text-lightBlack text-sm">Engineer</p>
            <p className="text-lightBlack text-sm mt-3">Bert</p>
            <p className="text-lightBlack text-sm mt-3">Van Duivendijk</p>
            <p className="text-lightBlack text-sm mt-3">ABC Address</p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4 shadow-md mt-2 mx-2 py-4 px-3">
        <div className="col-span-1 border-[1px] border-[rgba(0,0,0,.1)] rounded-lg h-[110px] flex flex-col justify-center items-center">
          <p className="text-2xl font-bold text-[rgba(0,0,0,.8)]">10</p>
          <p className="text-sm font-medium mt-1 text-[rgba(0,0,0,.8)]">
            Deals
          </p>
        </div>
        <div className="col-span-1 border-[1px] border-[rgba(0,0,0,.1)] rounded-lg h-[110px] flex flex-col justify-center items-center">
          <p className="text-2xl font-bold text-[rgba(0,0,0,.8)]">$25k</p>
          <p className="text-sm font-medium mt-1 text-[rgba(0,0,0,.8)]">
            Purchases
          </p>
        </div>
        <div className="col-span-1 border-[1px] border-[rgba(0,0,0,.1)] rounded-lg h-[110px] flex flex-col justify-center items-center">
          <p className="text-2xl font-bold text-[rgba(0,0,0,.8)]">$85k</p>
          <p className="text-sm font-medium mt-1 text-[rgba(0,0,0,.8)]">
            Life Time Value (LTV)
          </p>
        </div>
        <div className="col-span-1 border-[1px] border-[rgba(0,0,0,.1)] rounded-lg h-[110px] flex flex-col justify-center items-center">
          <p className="text-2xl font-bold text-[rgba(0,0,0,.8)]">25 Days</p>
          <p className="text-sm font-medium mt-1 text-[rgba(0,0,0,.8)]">
            Last Contact
          </p>
        </div>
        <div className="col-span-1 border-[1px] border-[rgba(0,0,0,.1)] rounded-lg h-[110px] flex flex-col justify-center items-center">
          <p className="text-2xl font-bold text-[rgba(0,0,0,.8)]">90 Days</p>
          <p className="text-sm font-medium mt-1 text-[rgba(0,0,0,.8)]">
            Last Order
          </p>
        </div>
        <div className="col-span-1 border-[1px] border-[rgba(0,0,0,.1)] rounded-lg h-[110px] flex flex-col justify-center items-center">
          <p className="text-2xl font-bold text-[rgba(0,0,0,.8)]">111</p>
          <p className="text-sm font-medium mt-1 text-[rgba(0,0,0,.8)]">
            RFM Score
          </p>
        </div>
      </div>
    </div>
  );
};

export default Summary;
